import moment from 'moment';

import { fetchMilestone } from '../actions/milestones';

import { getMilestone } from '../services/store-service';

import { getEarliestDate, getLatestDate, getToday } from './date';

export const getMilestonesStart = milestones => {
    const milestonesWithStart = milestones.filter(({ start }) => Boolean(start));
    return getEarliestDate(milestonesWithStart.length ? milestonesWithStart.map(milestone => milestone.start) : [new Date()]);
}

export const getMilestonesEnd = milestones => {
    const milestonesWithEnd = milestones.filter(({ end }) => Boolean(end));
    return getLatestDate(milestonesWithEnd.length ? milestonesWithEnd.map(milestone => milestone.end) : [new Date()]);
}

export const getMilestoneType = ({ statistic, end }) => {
    const progress = getMilestoneProgress({ statistic });

    if (milestoneHasOverdueTasks({ statistic, end })) {
        return 'overdue';
    }

    if (!progress) {
        return 'default';
    }

    if (progress === 100) {
        return 'completed';
    }
    return 'in-progress';
}

export const getMilestoneProgress = ({ statistic }) => {
    if (!statistic) {
        return 0;
    }

    const totalTasks = getMilestoneTasksCount({ statistic });

    if (!totalTasks) {
        return 0;
    }

    return Math.round(getMilestoneCompletedTasksCount({ statistic }) / totalTasks * 100);
}

const getMilestoneTasksCount = ({ statistic }) => {
    if (!statistic) {
        return 0;
    }

    return parseInt(statistic.total, 10);
}

export const getMilestoneOpenTasksCount = ({ statistic }) => {
    if (!statistic) {
        return 0;
    }

    return parseInt(statistic.total, 10) - parseInt(statistic.completed, 10);
}

export const getMilestoneCompletedTasksCount = ({ statistic }) => {
    if (!statistic) {
        return 0;
    }

    return parseInt(statistic.completed, 10);
}

export const milestoneHasOverdueTasks = ({ statistic, end }) => {
    if (!statistic || !end) {
        return false;
    }

    const milestoneEnded = moment(end).diff(getToday(), 'days') < 0;

    if (!milestoneEnded) {
        return false;
    }

    return Boolean(getMilestoneOpenTasksCount({ statistic }));
}

export const resolveMilestones = (milestonesIds, forcePromise, forceArray) => {
    let shouldFetch = false;

    const milestones = milestonesIds.map(milestone => milestone.id || milestone).map(milestoneId => {
        const milestone = getMilestone(milestoneId);

        if (!milestone) {
            shouldFetch = true;

            return fetchMilestone(milestoneId);
        }

        return milestone;
    });

    if (forceArray) {
        return milestones.filter(milestone => !(milestone instanceof Promise));
    }

    if (!shouldFetch) {
        if (forcePromise) {
            return Promise.resolve(milestones);
        }

        return milestones;
    } else {
        return Promise.all(milestones);
    }
}
